/**
 * ヘッダーメニューのトグル機能
 * js-header-menu-triggerをクリックしたら、自身とl-header-navにis-openクラスを追加/削除
 * ナビゲーションのaタグをクリックしたら、is-openクラスを削除
 * is-openが付与されたら、ページのスクロール位置を固定
 * l-header-navの背景（::before）をクリックしたら、is-openを削除
 */
export const headerMenu = () => {
	const trigger = document.querySelector('.js-header-menu-trigger')
	const nav = document.querySelector('.l-header-nav')
	const body = document.body

	if (!trigger || !nav) {
		return
	}

	let scrollPosition = 0

	// スクロールを固定する関数
	const lockScroll = () => {
		scrollPosition = window.pageYOffset
		body.style.position = 'fixed'
		body.style.top = `-${scrollPosition}px`
		body.style.width = '100%'
		body.style.overflow = 'hidden'
	}

	// スクロール固定を解除する関数
	const unlockScroll = () => {
		body.style.position = ''
		body.style.top = ''
		body.style.width = ''
		body.style.overflow = ''
		window.scrollTo(0, scrollPosition)
	}

	// メニューの開閉状態を管理する関数
	const toggleMenu = (isOpen) => {
		if (isOpen) {
			trigger.classList.add('is-open')
			nav.classList.add('is-open')
			lockScroll()
		} else {
			trigger.classList.remove('is-open')
			nav.classList.remove('is-open')
			unlockScroll()
		}
	}

	// トリガーのクリックイベント
	trigger.addEventListener('click', () => {
		const isOpen = trigger.classList.contains('is-open')
		toggleMenu(!isOpen)
	})

	// ナビゲーション内のaタグのクリックイベント
	const navLinks = nav.querySelectorAll('a')
	navLinks.forEach((link) => {
		link.addEventListener('click', () => {
			if (
				trigger.classList.contains('is-open') &&
				nav.classList.contains('is-open')
			) {
				toggleMenu(false)
			}
		})
	})

	// l-header-navの背景（::before）をクリックしたときに閉じる
	const navList = nav.querySelector('.l-header-nav-list')
	nav.addEventListener('click', (e) => {
		if (
			trigger.classList.contains('is-open') &&
			nav.classList.contains('is-open')
		) {
			// クリックされた要素がl-header-nav-list内でない場合（背景部分）
			if (navList && !navList.contains(e.target)) {
				toggleMenu(false)
			}
		}
	})
}
